function parseGwei(raw: string | undefined): number | null {
  const s = raw?.trim() ?? '';
  if (!s) {
    return null;
  }
  const n = Number(s);
  if (!Number.isFinite(n) || n < 0) {
    return null;
  }
  return n;
}

function formatGwei(n: number): string {
  // keep practical precision for UI input while trimming noise
  return n.toFixed(6).replace(/\.?0+$/, '');
}

export function prefillEip1559Gwei(
  gasPriceGwei: string | undefined,
  baseFeeGwei: string | undefined,
): { maxFeeGwei: string; priorityFeeGwei: string } | null {
  const gasPrice = parseGwei(gasPriceGwei);
  const baseFee = parseGwei(baseFeeGwei);
  if (gasPrice === null || baseFee === null) {
    return null;
  }
  let priority = gasPrice - baseFee;
  if (!Number.isFinite(priority) || priority <= 0) {
    priority = gasPrice > 0 ? Math.max(0.1, Math.min(2, gasPrice * 0.1)) : 0.1;
  }
  let max = baseFee + priority;
  if (gasPrice > max) {
    max = gasPrice;
  }
  return {
    maxFeeGwei: formatGwei(max),
    priorityFeeGwei: formatGwei(priority),
  };
}
